import * as React from 'react';
import { st, classes } from './ToggleSwitch.st.css';
import { CoreToggleSwitch } from '../internal/WixUiCoreComponents/components/CoreToggleSwitch';
export class ToggleSwitch extends React.Component {
    render() {
        const { checked, disabled, className, ...rest } = this.props;
        return (React.createElement(CoreToggleSwitch, { checked: checked, disabled: disabled, ...rest, className: st(classes.root, { checked, disabled }, className) }));
    }
}
ToggleSwitch.displayName = 'ToggleSwitch';
ToggleSwitch.defaultProps = { ...CoreToggleSwitch.defaultProps };
//# sourceMappingURL=ToggleSwitch.js.map